import {AssessmentHistory} from '@/state/models/AssessmentHistory';
import {Student} from '@/state/models/Student';
import subDays from 'date-fns/sub_days';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';
import {Settings} from '@/state/models/Settings';
import {Class} from '@/state/models/Class';
import {Test} from '@/state/models/Test';
import {QuestionPassFail} from '@/state/models/QuestionPassFail';
import {Answer} from '@/state/models/Answer';
import {QuestionMultipleChoice} from '@/state/models/QuestionMultipleChoice';
import {Choice} from '@/state/models/Choice';
import {Question} from '@/state/models/Question';

export class TeacherHelperApi {
    public constructor() {
        // TODO: create web client
    }

    nextHistoryId: number = 1;
    history: AssessmentHistory[] = [
        new AssessmentHistory(
            new Date('2018-10-17T15:00:00.000'),
            1,
            2,
            new Map<number, Answer>([
                [1, new Answer('fail', 'pass')],
                [2, new Answer('pass', 'pass')],
                [3, new Answer('pass', 'pass')],
                [4, new Answer('pass', 'pass')],
                [5, new Answer('pass', 'pass')],
                [6, new Answer('pass', 'pass')],
                [7, new Answer('pass', 'pass')],
                [8, new Answer('pass', 'pass')],
                [9, new Answer('pass', 'pass')],
                [10, new Answer('pass', 'pass')],
                [11, new Answer('fail', 'pass')],
                [12, new Answer('fail', 'pass')],
                [13, new Answer('pass', 'pass')],
                [14, new Answer('fail', 'pass')],
                [15, new Answer('pass', 'pass')],
                [16, new Answer('fail', 'pass')],
                [17, new Answer('pass', 'pass')],
                [18, new Answer('pass', 'pass')],
                [19, new Answer('fail', 'pass')],
            ]),
            this.nextHistoryId++),
        new AssessmentHistory(
            new Date('2018-11-17T15:00:00.000'),
            1,
            2,
            new Map([
                [1, new Answer('fail', 'pass')],
                [2, new Answer('pass', 'pass')],
                [3, new Answer('pass', 'pass')],
                [4, new Answer('pass', 'pass')],
                [5, new Answer('pass', 'pass')],
                [6, new Answer('pass', 'pass')],
                [7, new Answer('pass', 'pass')],
                [8, new Answer('pass', 'pass')],
                [9, new Answer('pass', 'pass')],
                [10, new Answer('pass', 'pass')],
                [11, new Answer('fail', 'pass')],
                [12, new Answer('fail', 'pass')],
                [13, new Answer('pass', 'pass')],
                [14, new Answer('pass', 'pass')],
                [15, new Answer('pass', 'pass')],
                [16, new Answer('fail', 'pass')],
                [17, new Answer('pass', 'pass')],
                [18, new Answer('pass', 'pass')],
                [19, new Answer('fail', 'pass')],

            ]),
            this.nextHistoryId++),
        new AssessmentHistory(
            new Date('2018-12-17T15:00:00.000'),
            1,
            2,
            new Map([
                [1, new Answer('fail', 'pass')],
                [2, new Answer('pass', 'pass')],
                [3, new Answer('pass', 'pass')],
                [4, new Answer('pass', 'pass')],
                [5, new Answer('pass', 'pass')],
                [6, new Answer('pass', 'pass')],
                [7, new Answer('pass', 'pass')],
                [8, new Answer('pass', 'pass')],
                [9, new Answer('pass', 'pass')],
                [10, new Answer('pass', 'pass')],
                [11, new Answer('fail', 'pass')],
                [12, new Answer('fail', 'pass')],
                [13, new Answer('pass', 'pass')],
                [14, new Answer('pass', 'pass')],
                [15, new Answer('pass', 'pass')],
                [16, new Answer('fail', 'pass')],
                [17, new Answer('pass', 'pass')],
                [18, new Answer('pass', 'pass')],
                [19, new Answer('fail', 'pass')],
            ]),
            this.nextHistoryId++),
        new AssessmentHistory(
            new Date('2019-01-17T15:00:00.000'),
            1,
            2,
            new Map([
                [1, new Answer('fail', 'pass')],
                [2, new Answer('pass', 'pass')],
                [3, new Answer('pass', 'pass')],
                [4, new Answer('pass', 'pass')],
                [5, new Answer('pass', 'pass')],
                [6, new Answer('pass', 'pass')],
                [7, new Answer('pass', 'pass')],
                [8, new Answer('fail', 'pass')],
                [9, new Answer('pass', 'pass')],
                [10, new Answer('pass', 'pass')],
                [11, new Answer('fail', 'pass')],
                [12, new Answer('fail', 'pass')],
                [13, new Answer('pass', 'pass')],
                [14, new Answer('fail', 'pass')],
                [15, new Answer('pass', 'pass')],
                [16, new Answer('fail', 'pass')],
                [17, new Answer('fail', 'pass')],
                [18, new Answer('pass', 'pass')],
                [19, new Answer('fail', 'pass')],

            ]),
            this.nextHistoryId++),
        new AssessmentHistory(
            new Date('2019-02-17T15:00:00.000'),
            1,
            1,
            new Map([
                [1, new Answer('pass', 'pass')],
                [2, new Answer('pass', 'pass')],
                [3, new Answer('pass', 'pass')],
                [4, new Answer('pass', 'pass')],
                [5, new Answer('pass', 'pass')],
                [6, new Answer('pass', 'pass')],
                [7, new Answer('pass', 'pass')],
                [8, new Answer('pass', 'pass')],
                [9, new Answer('pass', 'pass')],
                [10, new Answer('pass', 'pass')],
                [11, new Answer('fail', 'pass')],
                [12, new Answer('fail', 'pass')],
                [13, new Answer('pass', 'pass')],
                [14, new Answer('pass', 'pass')],
                [15, new Answer('pass', 'pass')],
                [16, new Answer('fail', 'pass')],
                [17, new Answer('pass', 'pass')],
                [18, new Answer('pass', 'pass')],
                [19, new Answer('fail', 'pass')],
            ]),
            this.nextHistoryId++),
        new AssessmentHistory(
            new Date('2019-03-17T15:00:00.000'),
            2,
            1,
            new Map([
                [20, new Answer('pass', 'pass')],
                [21, new Answer('pass', 'pass')],
                [22, new Answer('pass', 'pass')],
                [23, new Answer('pass', 'pass')],
                [24, new Answer('pass', 'pass')],
                [25, new Answer('pass', 'pass')],
                [26, new Answer('pass', 'pass')],
                [27, new Answer('pass', 'pass')],
                [28, new Answer('pass', 'pass')],
                [29, new Answer('pass', 'pass')],
                [30, new Answer('fail', 'pass')],
                [31, new Answer('pass', 'pass')],
                [32, new Answer('pass', 'pass')],
                [33, new Answer('pass', 'pass')],
                [34, new Answer('pass', 'pass')],
                [35, new Answer('pass', 'pass')],
                [36, new Answer('pass', 'pass')],
                [37, new Answer('pass', 'pass')],
                [38, new Answer('fail', 'pass')],

            ]),
            this.nextHistoryId++),
    ];
    assessments: Test[] = [
        new Test(15, 'Basic animal knowledge', 'Kindergarten - Animal World - multiple choice', [
            {id: 260}, {id: 261}, {id: 262}
        ]),
        {
            assessmentId: 14,
            title: 'Short Test',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 240},
                {id: 241},
                {id: 242},
            ],
        },
        {
            assessmentId: 1,
            title: 'Red words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 1},
                {id: 2},
                {id: 3},
                {id: 4},
                {id: 5},
                {id: 6},
                {id: 7},
                {id: 8},
                {id: 9},
                {id: 10},
                {id: 11},
                {id: 12},
                {id: 13},
                {id: 14},
                {id: 15},
                {id: 16},
                {id: 17},
                {id: 18},
                {id: 19},
            ],
        },
        {
            assessmentId: 2,
            title: 'Orange words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 20},
                {id: 21},
                {id: 22},
                {id: 23},
                {id: 24},
                {id: 25},
                {id: 26},
                {id: 27},
                {id: 28},
                {id: 29},
                {id: 30},
                {id: 31},
                {id: 32},
                {id: 33},
                {id: 34},
                {id: 35},
                {id: 36},
                {id: 37},
                {id: 38},
                {id: 39},
            ],
        },
        {
            assessmentId: 3,
            title: 'Yellow words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 40},
                {id: 41},
                {id: 42},
                {id: 43},
                {id: 44},
                {id: 45},
                {id: 46},
                {id: 47},
                {id: 48},
                {id: 49},
                {id: 50},
                {id: 51},
                {id: 52},
                {id: 53},
                {id: 54},
                {id: 55},
                {id: 56},
                {id: 57},
                {id: 58},
                {id: 59},
            ],
        },
        {
            assessmentId: 4,
            title: 'Green words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 60},
                {id: 61},
                {id: 62},
                {id: 63},
                {id: 64},
                {id: 65},
                {id: 66},
                {id: 67},
                {id: 68},
                {id: 69},
                {id: 70},
                {id: 71},
                {id: 72},
                {id: 73},
                {id: 74},
                {id: 75},
                {id: 76},
                {id: 77},
                {id: 78},
                {id: 79},
            ],
        },
        {
            assessmentId: 5,
            title: 'Blue words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 80},
                {id: 81},
                {id: 82},
                {id: 83},
                {id: 84},
                {id: 85},
                {id: 86},
                {id: 87},
                {id: 88},
                {id: 89},
                {id: 90},
                {id: 91},
                {id: 92},
                {id: 93},
                {id: 94},
                {id: 95},
                {id: 96},
                {id: 97},
                {id: 98},
                {id: 99},
            ],
        },
        {
            assessmentId: 6,
            title: 'Purple words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 100},
                {id: 101},
                {id: 102},
                {id: 103},
                {id: 104},
                {id: 105},
                {id: 106},
                {id: 107},
                {id: 108},
                {id: 109},
                {id: 110},
                {id: 111},
                {id: 112},
                {id: 113},
                {id: 114},
                {id: 115},
                {id: 116},
                {id: 117},
                {id: 118},
                {id: 119},
            ],
        },
        {
            assessmentId: 7,
            title: 'Pink words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 120},
                {id: 121},
                {id: 122},
                {id: 123},
                {id: 124},
                {id: 125},
                {id: 126},
                {id: 127},
                {id: 128},
                {id: 129},
                {id: 130},
                {id: 131},
                {id: 132},
                {id: 133},
                {id: 134},
                {id: 135},
                {id: 136},
                {id: 137},
                {id: 138},
                {id: 139},
            ],
        },
        {
            assessmentId: 8,
            title: 'Dark pink words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 140},
                {id: 141},
                {id: 142},
                {id: 143},
                {id: 144},
                {id: 145},
                {id: 146},
                {id: 147},
                {id: 148},
                {id: 149},
                {id: 150},
                {id: 151},
                {id: 152},
                {id: 153},
                {id: 154},
                {id: 155},
                {id: 156},
                {id: 157},
                {id: 158},
                {id: 159},
            ],
        },
        {
            assessmentId: 9,
            title: 'Light green words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 160},
                {id: 161},
                {id: 162},
                {id: 163},
                {id: 164},
                {id: 165},
                {id: 166},
                {id: 167},
                {id: 168},
                {id: 169},
                {id: 170},
                {id: 171},
                {id: 172},
                {id: 173},
                {id: 174},
                {id: 175},
                {id: 176},
                {id: 177},
                {id: 178},
                {id: 179},
            ],
        },
        {
            assessmentId: 10,
            title: 'Golden words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 180},
                {id: 181},
                {id: 182},
                {id: 183},
                {id: 184},
                {id: 185},
                {id: 186},
                {id: 187},
                {id: 188},
                {id: 189},
                {id: 190},
                {id: 191},
                {id: 192},
                {id: 193},
                {id: 194},
                {id: 195},
                {id: 196},
                {id: 197},
                {id: 198},
                {id: 199},
            ],
        },
        {
            assessmentId: 11,
            title: 'Grey words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 200},
                {id: 201},
                {id: 202},
                {id: 203},
                {id: 204},
                {id: 205},
                {id: 206},
                {id: 207},
                {id: 208},
                {id: 209},
                {id: 210},
                {id: 211},
                {id: 212},
                {id: 213},
                {id: 214},
                {id: 215},
                {id: 216},
                {id: 217},
                {id: 218},
                {id: 219},
            ],
        },
        {
            assessmentId: 12,
            title: 'Teal words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 220},
                {id: 221},
                {id: 222},
                {id: 223},
                {id: 224},
                {id: 225},
                {id: 226},
                {id: 227},
                {id: 228},
                {id: 229},
                {id: 230},
                {id: 231},
                {id: 232},
                {id: 233},
                {id: 234},
                {id: 235},
                {id: 236},
                {id: 237},
                {id: 238},
                {id: 239},
            ],
        },
        {
            assessmentId: 13,
            title: 'White words',
            headline: 'Kindergarten - Sight words',
            questions: [
                {id: 240},
                {id: 241},
                {id: 242},
                {id: 243},
                {id: 244},
                {id: 245},
                {id: 246},
                {id: 247},
                {id: 248},
                {id: 249},
                {id: 250},
                {id: 251},
                {id: 252},
                {id: 253},
                {id: 254},
                {id: 255},
                {id: 256},
                {id: 257},
                {id: 258},
                {id: 259},
            ],
        },
    ];
    classes: Class[] = [
        new Class('K1 Explorers', 'A medium class', 1, [1, 2, 3]),
        new Class('K1 Adventurers', 'A small class', 2, []),
    ];

    public getSettings(): PromiseLike<Settings> {
        return Promise.resolve({
            datePickerPresets: TeacherHelperApi.calculatePresets()
        });
    }

    public getQuestionsByIds(ids: number[]): PromiseLike<Question[]> {
        const questions: Array<Question> = [
            new QuestionPassFail(1, 'me'),
            new QuestionPassFail(2, 'a'),
            new QuestionPassFail(3, 'and'),
            new QuestionPassFail(4, 'can'),
            new QuestionPassFail(5, 'come'),
            new QuestionPassFail(6, 'do'),
            new QuestionPassFail(7, 'have'),
            new QuestionPassFail(8, 'my'),
            new QuestionPassFail(9, 'some'),
            new QuestionPassFail(10, 'said'),
            new QuestionPassFail(11, 'look'),
            new QuestionPassFail(12, 'to'),
            new QuestionPassFail(13, 'no'),
            new QuestionPassFail(14, 'the'),
            new QuestionPassFail(15, 'see'),
            new QuestionPassFail(16, 'is'),
            new QuestionPassFail(17, 'you'),
            new QuestionPassFail(18, 'I'),
            new QuestionPassFail(19, 'at'),
            new QuestionPassFail(20, 'but'),
            new QuestionPassFail(21, 'for'),
            new QuestionPassFail(22, 'up'),
            new QuestionPassFail(23, 'go'),
            new QuestionPassFail(24, 'that'),
            new QuestionPassFail(25, 'off'),
            new QuestionPassFail(26, 'in'),
            new QuestionPassFail(27, 'put'),
            new QuestionPassFail(28, 'on'),
            new QuestionPassFail(29, 'it'),
            new QuestionPassFail(30, 'are'),
            new QuestionPassFail(31, 'we'),
            new QuestionPassFail(32, 'with'),
            new QuestionPassFail(33, 'like'),
            new QuestionPassFail(34, 'they'),
            new QuestionPassFail(35, 'love'),
            new QuestionPassFail(36, 'play'),
            new QuestionPassFail(37, 'am'),
            new QuestionPassFail(38, 'make'),
            new QuestionPassFail(39, 'all'),
            new QuestionPassFail(40, 'well'),
            new QuestionPassFail(41, 'good'),
            new QuestionPassFail(42, 'into'),
            new QuestionPassFail(43, 'want'),
            new QuestionPassFail(44, 'run'),
            new QuestionPassFail(45, 'saw'),
            new QuestionPassFail(46, 'this'),
            new QuestionPassFail(47, 'must'),
            new QuestionPassFail(48, 'under'),
            new QuestionPassFail(49, 'get'),
            new QuestionPassFail(50, 'too'),
            new QuestionPassFail(51, 'four'),
            new QuestionPassFail(52, 'came'),
            new QuestionPassFail(53, 'father'),
            new QuestionPassFail(54, 'new'),
            new QuestionPassFail(55, 'will'),
            new QuestionPassFail(56, 'be'),
            new QuestionPassFail(57, 'yes'),
            new QuestionPassFail(58, 'was'),
            new QuestionPassFail(59, 'she'),
            new QuestionPassFail(60, 'of'),
            new QuestionPassFail(61, 'night'),
            new QuestionPassFail(62, 'ate'),
            new QuestionPassFail(63, 'went'),
            new QuestionPassFail(64, 'again'),
            new QuestionPassFail(65, 'ride'),
            new QuestionPassFail(66, 'now'),
            new QuestionPassFail(67, 'because'),
            new QuestionPassFail(68, 'has'),
            new QuestionPassFail(69, 'eat'),
            new QuestionPassFail(70, 'so'),
            new QuestionPassFail(71, 'say'),
            new QuestionPassFail(72, 'did'),
            new QuestionPassFail(73, 'from'),
            new QuestionPassFail(74, 'day'),
            new QuestionPassFail(75, 'what'),
            new QuestionPassFail(76, 'our'),
            new QuestionPassFail(77, 'out'),
            new QuestionPassFail(78, 'his'),
            new QuestionPassFail(79, 'there'),
            new QuestionPassFail(80, 'as'),
            new QuestionPassFail(81, 'had'),
            new QuestionPassFail(82, 'once'),
            new QuestionPassFail(83, 'live'),
            new QuestionPassFail(84, 'give'),
            new QuestionPassFail(85, 'after'),
            new QuestionPassFail(86, 'who'),
            new QuestionPassFail(87, 'little'),
            new QuestionPassFail(88, 'her'),
            new QuestionPassFail(89, 'then'),
            new QuestionPassFail(90, 'could'),
            new QuestionPassFail(91, 'animal'),
            new QuestionPassFail(92, 'still'),
            new QuestionPassFail(93, 'an'),
            new QuestionPassFail(94, 'mother'),
            new QuestionPassFail(95, 'first'),
            new QuestionPassFail(96, 'away'),
            new QuestionPassFail(97, 'let'),
            new QuestionPassFail(98, 'by'),
            new QuestionPassFail(99, 'may'),
            new QuestionPassFail(100, 'should'),
            new QuestionPassFail(101, 'him'),
            new QuestionPassFail(102, 'over'),
            new QuestionPassFail(103, 'when'),
            new QuestionPassFail(104, 'going'),
            new QuestionPassFail(105, 'them'),
            new QuestionPassFail(106, 'think'),
            new QuestionPassFail(107, 'round'),
            new QuestionPassFail(108, 'thank'),
            new QuestionPassFail(109, 'know'),
            new QuestionPassFail(110, 'take'),
            new QuestionPassFail(111, 'every'),
            new QuestionPassFail(112, 'ask'),
            new QuestionPassFail(113, 'just'),
            new QuestionPassFail(114, 'fly'),
            new QuestionPassFail(115, 'stop'),
            new QuestionPassFail(116, 'old'),
            new QuestionPassFail(117, 'were'),
            new QuestionPassFail(118, 'open'),
            new QuestionPassFail(119, 'any'),
            new QuestionPassFail(120, 'keep'),
            new QuestionPassFail(121, 'six'),
            new QuestionPassFail(122, 'eight'),
            new QuestionPassFail(123, 'laugh'),
            new QuestionPassFail(124, 'much'),
            new QuestionPassFail(125, 'only'),
            new QuestionPassFail(126, 'long'),
            new QuestionPassFail(127, 'seven'),
            new QuestionPassFail(128, 'small'),
            new QuestionPassFail(129, 'start'),
            new QuestionPassFail(130, 'never'),
            new QuestionPassFail(131, 'try'),
            new QuestionPassFail(132, 'own'),
            new QuestionPassFail(133, 'fall'),
            new QuestionPassFail(134, 'today'),
            new QuestionPassFail(135, 'full'),
            new QuestionPassFail(136, 'hot'),
            new QuestionPassFail(137, 'cut'),
            new QuestionPassFail(138, 'grow'),
            new QuestionPassFail(139, 'show'),
            new QuestionPassFail(140, 'pick'),
            new QuestionPassFail(141, 'hurt'),
            new QuestionPassFail(142, 'hold'),
            new QuestionPassFail(143, 'draw'),
            new QuestionPassFail(144, 'warm'),
            new QuestionPassFail(145, 'myself'),
            new QuestionPassFail(146, 'bring'),
            new QuestionPassFail(147, 'ten'),
            new QuestionPassFail(148, 'far'),
            new QuestionPassFail(149, 'shall'),
            new QuestionPassFail(150, 'line'),
            new QuestionPassFail(151, 'clean'),
            new QuestionPassFail(152, 'carry'),
            new QuestionPassFail(153, 'walk'),
            new QuestionPassFail(154, 'drink'),
            new QuestionPassFail(155, 'light'),
            new QuestionPassFail(156, 'wash'),
            new QuestionPassFail(157, 'together'),
            new QuestionPassFail(158, 'purple'),
            new QuestionPassFail(159, 'orange'),
            new QuestionPassFail(160, 'always'),
            new QuestionPassFail(161, 'if'),
            new QuestionPassFail(162, 'us'),
            new QuestionPassFail(163, 'sleep'),
            new QuestionPassFail(164, 'tell'),
            new QuestionPassFail(165, 'sit'),
            new QuestionPassFail(166, 'before'),
            new QuestionPassFail(167, 'call'),
            new QuestionPassFail(168, 'their'),
            new QuestionPassFail(169, 'right'),
            new QuestionPassFail(170, 'buy'),
            new QuestionPassFail(171, 'cold'),
            new QuestionPassFail(172, 'pull'),
            new QuestionPassFail(173, 'those'),
            new QuestionPassFail(174, 'why'),
            new QuestionPassFail(175, 'made'),
            new QuestionPassFail(176, 'both'),
            new QuestionPassFail(177, 'five'),
            new QuestionPassFail(178, 'very'),
            new QuestionPassFail(179, 'green'),
            new QuestionPassFail(180, 'fast'),
            new QuestionPassFail(181, 'best'),
            new QuestionPassFail(182, 'upon'),
            new QuestionPassFail(183, 'these'),
            new QuestionPassFail(184, 'many'),
            new QuestionPassFail(185, 'got'),
            new QuestionPassFail(186, 'or'),
            new QuestionPassFail(187, 'sing'),
            new QuestionPassFail(188, 'read'),
            new QuestionPassFail(189, 'gave'),
            new QuestionPassFail(190, 'goes'),
            new QuestionPassFail(191, 'your'),
            new QuestionPassFail(192, 'which'),
            new QuestionPassFail(193, 'been'),
            new QuestionPassFail(194, 'use'),
            new QuestionPassFail(195, 'its'),
            new QuestionPassFail(196, 'found'),
            new QuestionPassFail(197, 'don\'t'),
            new QuestionPassFail(198, 'work'),
            new QuestionPassFail(199, 'wish'),
            new QuestionPassFail(200, 'around'),
            new QuestionPassFail(201, 'letter'),
            new QuestionPassFail(202, 'done'),
            new QuestionPassFail(203, 'write'),
            new QuestionPassFail(204, 'would'),
            new QuestionPassFail(205, 'about'),
            new QuestionPassFail(206, 'does'),
            new QuestionPassFail(207, 'better'),
            new QuestionPassFail(208, 'learn'),
            new QuestionPassFail(209, 'point'),
            new QuestionPassFail(210, 'how'),
            new QuestionPassFail(211, 'each'),
            new QuestionPassFail(212, 'answer'),
            new QuestionPassFail(213, 'page'),
            new QuestionPassFail(214, 'word'),
            new QuestionPassFail(215, 'more'),
            new QuestionPassFail(216, 'world'),
            new QuestionPassFail(217, 'number'),
            new QuestionPassFail(218, 'time'),
            new QuestionPassFail(219, 'other'),
            new QuestionPassFail(220, 'than'),
            new QuestionPassFail(221, 'way'),
            new QuestionPassFail(222, 'water'),
            new QuestionPassFail(223, 'people'),
            new QuestionPassFail(224, 'back'),
            new QuestionPassFail(225, 'thing'),
            new QuestionPassFail(226, 'great'),
            new QuestionPassFail(227, 'most'),
            new QuestionPassFail(228, 'name'),
            new QuestionPassFail(229, 'man'),
            new QuestionPassFail(230, 'through'),
            new QuestionPassFail(231, 'mean'),
            new QuestionPassFail(232, 'sentence'),
            new QuestionPassFail(233, 'America'),
            new QuestionPassFail(234, 'oil'),
            new QuestionPassFail(235, 'part'),
            new QuestionPassFail(236, 'place'),
            new QuestionPassFail(237, 'house'),
            new QuestionPassFail(238, 'study'),
            new QuestionPassFail(239, 'year'),
            new QuestionPassFail(240, 'home'),
            new QuestionPassFail(241, 'boy'),
            new QuestionPassFail(242, 'end'),
            new QuestionPassFail(243, 'set'),
            new QuestionPassFail(244, 'another'),
            new QuestionPassFail(245, 'land'),
            new QuestionPassFail(246, 'need'),
            new QuestionPassFail(247, 'move'),
            new QuestionPassFail(248, 'hand'),
            new QuestionPassFail(249, 'men'),
            new QuestionPassFail(250, 'even'),
            new QuestionPassFail(251, 'same'),
            new QuestionPassFail(252, 'follow'),
            new QuestionPassFail(253, 'such'),
            new QuestionPassFail(254, 'large'),
            new QuestionPassFail(255, 'also'),
            new QuestionPassFail(256, 'kind'),
            new QuestionPassFail(257, 'picture'),
            new QuestionPassFail(258, 'different'),
            new QuestionPassFail(259, 'turn'),

            new QuestionMultipleChoice(260,
                'How many legs do spiders have?',
                [
                    new Choice('A', '6'),
                    new Choice('B', '7'),
                    new Choice('C', '8'),
                ],
                'C'),
            new QuestionMultipleChoice(261,
                'What animal are dogs similar to?',
                [
                    new Choice('A', 'Wolf'),
                    new Choice('B', 'Squirrel'),
                    new Choice('C', 'Cat'),
                ],
                'A'),
            new QuestionMultipleChoice(262,
                'What animal is the largest in the world?',
                [
                    new Choice('A', 'Rhino'),
                    new Choice('B', 'Elephant'),
                    new Choice('C', 'Whale'),
                ],
                'C'),
        ];

        let matchedQuestions: Array<Question> = [];
        if (ids){
            for (let q of questions) {
                for (let id of ids) {
                    if (id === q.id) {
                        matchedQuestions.push(q);
                    }
                }
            }
        }
        else {
            matchedQuestions = questions;
        }
        return Promise.resolve(matchedQuestions);
    }

    public getAssessments(ids: number[]) {
        return (!ids || ids.length === 0) ?
            Promise.resolve(this.assessments) :
            Promise.resolve(this.assessments.filter((a) =>{
                let index = ids.findIndex(i => {
                    let result = i === a.assessmentId;

                    return result;
                });
                return index > -1;
            }));
    }
    public searchAssessments() {
        return Promise.resolve(this.assessments);
    }

    public getHistory(ids: number[]): PromiseLike<AssessmentHistory[]> {
        return (!ids || ids.length === 0) ?
            Promise.resolve(this.history) :
            Promise.resolve(this.history.filter((h) => {
                let index = ids.findIndex(i => {
                    let result = i === h.id;
                    return result;
                });
                return index > -1;
            }));
    }
    public searchHistory(studentIds: number[] | undefined,
                         maxNumEntries: number | undefined,
                         startDate: Date | undefined,
                         endDate: Date | undefined) {
        const matchedHistory = this.history
            .filter(h => (studentIds ? studentIds.some(sid => sid === h.studentId) : true) &&
                (startDate ? h.timestamp >= startDate : true) &&
                (endDate ? h.timestamp <= endDate : true));
        let result = maxNumEntries ? matchedHistory.slice(-maxNumEntries) : matchedHistory;
        return Promise.resolve(result);
    }

    public postHistory(historyEntry: AssessmentHistory) {
        historyEntry.id = this.nextHistoryId++;
        this.history.push(historyEntry);
        return Promise.resolve(historyEntry);
    }

    public getStudents(ids: number[]) {
        const students: Student[] = [
            new Student(1, 'Marie', '', 'Curie'),
            new Student(2, 'Albert', '', 'Einstein'),
            new Student(3, 'Ada', 'Augusta', 'Lovelace'),
        ];
        return (!ids || !ids.length) ?
            Promise.resolve(students) :
            Promise.resolve(students.filter(s => ids.find(id => id === s.id)));
    }

    public searchStudents(searchQ: string) {
        return this.getStudents([]).then((sList) => {
            let matches = sList.filter(s => {
                let cleanQ = searchQ.toLocaleLowerCase();
                let firstNameMatch = (s.firstName && s.firstName.toLocaleLowerCase().indexOf(cleanQ) > -1);
                let middleNameMatch = (s.middleName && s.middleName.toLocaleLowerCase().indexOf(cleanQ) > -1);
                let lastNameMatch = (s.lastName && s.lastName.toLocaleLowerCase().indexOf(cleanQ) > -1);
                return firstNameMatch || middleNameMatch || lastNameMatch;
            });
            return Promise.resolve(matches);
        });
    }

    public getClasses(ids: number[]) : PromiseLike<Class[]> {
        let matchingClasses = (!ids || !ids.length) ?
            this.classes :
            this.classes.filter(c => ids.find(id => id === c.id));
        return Promise.resolve(matchingClasses);
    }

    public searchClasses(studentIds?: number[]) : PromiseLike<Class[]> {
        let result = this.classes;
        if (studentIds) {
            result = this.classes.filter(c =>
                c.studentIds &&
                c.studentIds.some(sid => studentIds.indexOf(sid) >= 0));
        }
        return Promise.resolve(result);
    }

    private static calculatePresets(): any[] {
        const tomorrow = addDays(new Date(), 1); //TODO: temporary work-around until DateRangePicker supports dynamic presets or menu-open event
        return [
            {
                label: 'Last 7 days',
                range: [TeacherHelperApi.formatDate(subDays(tomorrow, 7)), TeacherHelperApi.formatDate(tomorrow)]
            },
            {
                label: '1st quarter',
                range: [TeacherHelperApi.formatDate(new Date(2018, 7, 25)), TeacherHelperApi.formatDate(new Date(2018, 9, 30))]
            },
            {
                label: '2nd quarter',
                range: [TeacherHelperApi.formatDate(new Date(2018, 10, 10)), TeacherHelperApi.formatDate(new Date(2018, 11, 23))]
            },
            {
                label: '3rd quarter',
                range: [TeacherHelperApi.formatDate(new Date(2019, 0, 3)), TeacherHelperApi.formatDate(new Date(2019, 3, 15))]
            },
            {
                label: '4th quarter',
                range: [TeacherHelperApi.formatDate(new Date(2019, 4, 1)), TeacherHelperApi.formatDate(new Date(2019, 5, 15))]
            },
            {
                label: 'School year',
                range: [TeacherHelperApi.formatDate(new Date(2018, 7, 25)), TeacherHelperApi.formatDate(new Date(2019, 5, 15))]
            },
            {
                label: 'Past year',
                range: [TeacherHelperApi.formatDate(subDays(tomorrow, 365)), TeacherHelperApi.formatDate(tomorrow)]
            }
        ];
    }

    private static formatDate(date: Date): string {
        return format(date, 'YYYY-MM-DD');
    }
}
